import React from "react";
import { motion } from "framer-motion";
import {
  FaHome,
  FaUser,
  FaServer,
  FaHandshake,
  FaNetworkWired,
  FaBook,
  FaGlobe,
  FaFileAlt,
  FaFacebook,
  FaTwitter,
  FaGithub,
  FaDiscord,
  FaYoutube,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="mt-auto bg-black bg-opacity-90 backdrop-blur-md text-white py-8 relative">
      <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-red-700 via-red-500 to-red-700"></div>

      <div className="max-w-6xl mx-auto px-6 text-center">
        <motion.h2
          className="text-2xl font-bold mb-4 text-yellow-400 border-b-4 border-yellow-500 inline-block pb-2"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          Join Our Community!
        </motion.h2>

        <p className="mb-4 text-gray-300">
          Start enjoying the benefits of <strong>MENEL</strong> with Menelik's complete staking and mining solutions.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm mb-6">
          {[
            { name: "Explorer", icon: <FaHome />, href: "https://explorer.menelik.cc/" },
            { name: "Holders", icon: <FaUser />, href: "https://explorer.menelik.cc/top-addresses" },
            { name: "SmartNodes", icon: <FaServer />, href: "https://explorer.menelik.cc/smartnodes" },
            { name: "Claim Address", icon: <FaHandshake />, href: "https://explorer.menelik.cc/claim-address" },
            { name: "Peers", icon: <FaNetworkWired />, href: "https://explorer.menelik.cc/peerinfo" },
            { name: "API Docs", icon: <FaBook />, href: "https://explorer.menelik.cc/api/api-docs" },
            { name: "Roadmap", icon: <FaGlobe />, href: "https://roadmap.menelik.cc/", external: true },
            { name: "Whitepaper", icon: <FaFileAlt />, href: "https://menelikcoin.gitbook.io/whitepaper", external: true },
            { name: "Menelik Core Docs", icon: <FaFileAlt />, href: "https://menelikcoin.gitbook.io/menelikcoin-docs", external: true },
            { name: "ES Menelik Docs", icon: <FaFileAlt />, href: "https://docs.menelik.cc/", external: true },
          ].map((item, index) => (
            <a
              key={index}
              href={item.href}
              target={item.external ? "_blank" : ""}
              rel={item.external ? "noopener noreferrer" : ""}
              className="hover:text-yellow-400 flex items-center justify-center space-x-2 transition duration-300"
            >
              {item.icon}
              <span>{item.name}</span>
            </a>
          ))}
        </div>

        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <a
            href="#hero"
            className="inline-block px-6 py-2 bg-red-600 hover:bg-red-800 rounded-full font-semibold text-white transition duration-300"
          >
            Back to Top
          </a>
        </motion.div>

        <div className="flex justify-center space-x-6 mt-6">
          {[
            { icon: <FaFacebook />, href: "https://menelik.cc/" },
            { icon: <FaTwitter />, href: "https://x.com/menelikcoin" },
            { icon: <FaGithub />, href: "https://github.com/MenelikCoin/menelik/" },
            { icon: <FaDiscord />, href: "https://discord.gg/xjDSyeD2" },
            { icon: <FaYoutube />, href: "https://www.youtube.com/@Menelikcoin" },
          ].map((social, index) => (
            <a
              key={index}
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-yellow-400 transition duration-300"
            >
              {social.icon}
            </a>
          ))}
        </div>

        <p className="mt-6 text-gray-400 text-sm">
          &copy; {new Date().getFullYear()} Menelik. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
